import BaseElement from '@/components/purchase/checkout/seat-selection/modal/canvas/BaseElement';
import PriceStrip from '@/components/purchase/checkout/seat-selection/modal/canvas/PriceStrip';
import TextLabel from '@/components/purchase/checkout/seat-selection/modal/canvas/TextLabel';
import type { CompartmentDTO } from '@/types/dto/agent';
import { getElementState } from '@/utils/seatSelection';
import React from 'react';

interface CompartmentElementProps {
  element: CompartmentDTO;
  canvasHeight: number;
  xOffset?: number;
  yOffset?: number;
  onClick?: () => void;
  hoveredSeatId?: string;
  selectedReservationId?: string;
}

const CompartmentElement: React.FC<CompartmentElementProps> = ({
  element,
  canvasHeight,
  xOffset = 0,
  yOffset = 0,
  onClick,
  hoveredSeatId,
  selectedReservationId,
}) => {
  const width = 15;
  const height = 15;
  const center = { x: width / 2, y: height / 2 };
  const elementData = {
    ...element,
    selectedReservationId,
    hoveredSeatId,
  };

  const text = getElementState<string | number | undefined>(elementData, {
    elementPartOfBookingAndSelected: element.number,
    elementPartOfBookingAndNotSelected: element.number,
    elementPartOfBookingAndNotSelectedAndHovered: element.number,
    elementAvailableWithWheelchair: undefined,
    elementAvailableWithWheelchairAndHovered: undefined,
    elementAvailable: element.number,
    elementAvailableAndHovered: element.number,
    elementBlocked: undefined,
    elementBooked: undefined,
  });

  const isInteractable = getElementState<boolean>(elementData, {
    elementPartOfBookingAndSelected: false,
    elementPartOfBookingAndNotSelected: true,
    elementPartOfBookingAndNotSelectedAndHovered: true,
    elementAvailableWithWheelchair: true,
    elementAvailableWithWheelchairAndHovered: true,
    elementAvailable: true,
    elementAvailableAndHovered: true,
    elementBlocked: false,
    elementBooked: false,
  });

  const price = getElementState<number | undefined>(elementData, {
    elementPartOfBookingAndSelected: undefined,
    elementPartOfBookingAndNotSelected: undefined,
    elementPartOfBookingAndNotSelectedAndHovered: undefined,
    elementAvailableWithWheelchair: element.selectionFee?.amount,
    elementAvailableWithWheelchairAndHovered: element.selectionFee?.amount,
    elementAvailable: element.selectionFee?.amount,
    elementAvailableAndHovered: element.selectionFee?.amount,
    elementBlocked: undefined,
    elementBooked: undefined,
  });

  return (
    <BaseElement
      coordinates={element.coordinates}
      canvasHeight={canvasHeight}
      xOffset={xOffset}
      yOffset={yOffset}
      isInteractable={isInteractable}
      onClick={onClick}
    >
      {text && (
        <TextLabel x={center.x} y={center.y} text={text} color="#000000" />
      )}
      {price && (
        <PriceStrip price={price} width={width} xOffset={0} yOffset={30} />
      )}
    </BaseElement>
  );
};

export default CompartmentElement;
